import { render, staticRenderFns } from "./CulProduct.vue?vue&type=template&id=7db68e80&scoped=true"
import script from "./CulProduct.vue?vue&type=script&lang=js"
export * from "./CulProduct.vue?vue&type=script&lang=js"
import style0 from "./CulProduct.vue?vue&type=style&index=0&id=7db68e80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db68e80",
  null
  
)

export default component.exports